import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { SelectSharedComponent } from './select.component';

@NgModule({
    declarations: [
        SelectSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule
    ],
    exports: [
        SelectSharedComponent
    ]
})

export class SelectSharedModule {}
